import { axiosClient } from "./axiosClient"

export const PURCHASE_RETURN_PATH = '/api/v1/purchase-return'

export const addPurchaseReturn = (body) => {
    return axiosClient.post(PURCHASE_RETURN_PATH, body)
}

export const deletePurchaseReturn = (id) => {
    return axiosClient.delete(`${PURCHASE_RETURN_PATH}/${id}`)
}

export const getAllPurchaseReturns = ({ purchaseId = '' }) => {
    return axiosClient.get(`${PURCHASE_RETURN_PATH}?purchaseId=${purchaseId}`)
}

export const chargePurchaseReturn = (id) => {
    return axiosClient.put(`${PURCHASE_RETURN_PATH}/charge/${id}`)
}

export const dechargePurchaseReturn = (id) => {
    return axiosClient.put(`${PURCHASE_RETURN_PATH}/decharge/${id}`)
}

export const getPagePurchaseReturn = ({ lastId = '', id = '', supplierId = '', invoiceNumber = '' }) => {
    return axiosClient.get(`${PURCHASE_RETURN_PATH}/page?lastId=${lastId}&id=${id}&supplierId=${supplierId}&invoiceNumber=${invoiceNumber}`)
}